import Swiper from 'swiper/swiper-bundle.esm.js';
import { SWIPER_CONFIG, SWIPER_SIZES } from '../config/swiper';
import { breakpoints } from '../core/constants';
import { targetPixelSize } from '../utilities/fluid-design';

const carousels = document.querySelectorAll('.carousel');

function createSwiper(container, config = {}) {
    const slideSize = container.getAttribute('slide-width');
    const loop = container.getAttribute('loop');

    return new Swiper(container, {
        ...SWIPER_CONFIG,
        loop: loop == 'true' ? true : false,

        breakpoints: {
            [breakpoints.lg]: {
                slidesPerView: SWIPER_SIZES[slideSize],
                spaceBetween: targetPixelSize() * 48,
            },
        },

        ...config,
    });
}

carousels.forEach((carousel) => {
    const carouselOptions = {};

    if (carousel.classList.contains('carousel--cards')) {
        carouselOptions.slidesPerView = 1.2;

        carouselOptions.breakpoints = {
            [breakpoints.lg]: {
                slidesPerView: 4,
            },
        };
    }

    if (carousel.classList.contains('carousel--logo')) {
        carouselOptions.autoplay = {
            delay: 1,
            waitForTransition: false,
        };
        carouselOptions.loop = true;
        carouselOptions.navigation = false;
        carouselOptions.allowTouchMove = false;
        carouselOptions.grabCursor = false;
        carouselOptions.speed = 7500;
        carouselOptions.slidesPerView = 2;
        carouselOptions.centeredSlides = true;
        carouselOptions.spaceBetween = 48;
        carouselOptions.breakpoints = {
            [breakpoints.lg]: {
                slidesPerView: 7,
                spaceBetween: 92,
                centeredSlides: false,
            },
        };
    }

    createSwiper(carousel, carouselOptions);
});
